import { render, staticRenderFns } from "./HeaderWarms.vue?vue&type=template&id=5b4259cc&scoped=true&"
import script from "./HeaderWarms.vue?vue&type=script&lang=js&"
export * from "./HeaderWarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4259cc",
  null
  
)

export default component.exports